import { render, staticRenderFns } from "./EditorAddCardPanel.vue?vue&type=template&id=a1710940&scoped=true"
import script from "./EditorAddCardPanel.vue?vue&type=script&lang=js"
export * from "./EditorAddCardPanel.vue?vue&type=script&lang=js"
import style0 from "./EditorAddCardPanel.vue?vue&type=style&index=0&id=a1710940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1710940",
  null
  
)

export default component.exports